import Vue from 'vue'
import App from './App'
import router from './router'
import EventEmitter from '@/events/emitter'

// vuex
import store from './vuex/store'

Vue.config.productionTip = false

// Expose a getter for $bus
Object.defineProperties(Vue.prototype, {
	$bus: {
		get: function () {
			return EventEmitter
		}
	}
})

/* eslint-disable no-new */
new Vue({
	el: '#app',
	store,
	router,
	render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js